import SavedEmailStatusEnum from 'common/constants/SavedEmailStatusEnum';
export const NotificationContextDefaults = {
    announcements: [],
    getUserAnnouncements: undefined,
    unreadCount: 0,
    emailAddresses: [],
    getEmails: undefined,
    saveEmailAddress: undefined,
    isEmailSaved: SavedEmailStatusEnum.NONE,
    setIsEmailSaved: undefined,
    userTimeZone: undefined,
    getTimeZone: undefined,
};
